"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOwner = exports.isOwner = exports.getOwner = void 0;
function getOwner(own) {
    return own.ownerId;
}
exports.getOwner = getOwner;
function isOwner(own, userId) {
    return typeof userId === 'string' && own.ownerId === userId;
}
exports.isOwner = isOwner;
function setOwner(obj, userId) {
    return Object.assign({}, obj, {
        ownerId: userId,
    });
}
exports.setOwner = setOwner;
//# sourceMappingURL=ownable.js.map